import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleService 
{
  private locale:string = 'pt-BR';
  private currency:string = 'BRL';

  constructor(
    private translate:TranslateService
  ) { }

  setLocale(locale:string, currency:string)
  {
    this.locale = locale;
    this.currency = currency;
    return this.translate.use(locale);
  }

  getLocale()
  {
    return this.locale;
  }

  async getTranslation(path:string)
  {
    return this.translate.get(path).toPromise();
  }

  instantTranslation(path:string)
  {
    return this.translate.instant(path);
  }

  getCurrency()
  {
    if(this.currency === 'BRL' || this.currency === 'EUR')
      return this.currency;
    else
      throw new Error("Invalid Currency!");
  }

  getCurrencyString(value:number)
  {
    return value.toLocaleString(this.locale, { style: 'currency',  currency : this.currency });
  }

  getCountry()
  {
    switch(this.locale)
    {
      case 'pt-BR':
        return 'br';
      case 'en-IE':
        return 'ie';
      default:
        return 'br';
    }
  }
}
